import FloatingLogoAndButton from "../FloatingLogoAndButton/FloatingLogoAndButton";

export default function PrivacyPolicy() {
  return (
    <>
      <FloatingLogoAndButton />
      <div className="p-8 w-full mx-auto bg-black text-white text-sm leading-6 pt-36">
        <h1 className="text-2xl font-bold mb-4">Polityka prywatności</h1>

        <p className="mb-4">
          Szanujemy Twoją prywatność i dbamy o bezpieczeństwo danych osobowych,
          które nam powierzasz. Niniejsza polityka określa, jakie dane zbieramy,
          w jakim celu i na jakiej podstawie.
        </p>

        <h2 className="text-lg font-semibold mt-6 mb-2">
          1. Administrator danych
        </h2>
        <p className="mb-4">
          Administratorem danych osobowych jest WhiteBull Steakhouse. W sprawach
          związanych z przetwarzaniem danych możesz kontaktować się mailowo lub
          przez formularz kontaktowy.
        </p>

        <h2 className="text-lg font-semibold mt-6 mb-2">
          2. Jakie dane zbieramy
        </h2>
        <p className="mb-2">
          W zależności od interakcji, możemy przetwarzać następujące dane
          osobowe:
        </p>
        <ul className="list-disc pl-5 mb-4">
          <li>Imię i nazwisko (pole „Klient” w formularzu rezerwacji)</li>
          <li>Adres e-mail</li>
          <li>Numer telefonu</li>
          <li>
            Dane dotyczące rezerwacji (lokalizacja, data, godzina, liczba osób,
            pomieszczenie, uwagi)
          </li>
          <li>Adres e-mail podany do zapisu na newsletter</li>
          <li>
            Informacje o Twojej aktywności na stronie (przez Google Analytics –
            anonimowo)
          </li>
        </ul>

        <h2 className="text-lg font-semibold mt-6 mb-2">
          3. Cele przetwarzania
        </h2>
        <ul className="list-disc pl-5 mb-4">
          <li>Realizacja rezerwacji stolików</li>
          <li>Obsługa zapytań i kontakt z klientem</li>
          <li>
            Wysyłka informacji marketingowych (newsletter) – tylko za Twoją
            zgodą
          </li>
          <li>Analiza statystyk strony za pomocą Google Analytics</li>
        </ul>

        <h2 className="text-lg font-semibold mt-6 mb-2">
          4. Podstawa prawna przetwarzania
        </h2>
        <p className="mb-4">
          Dane przetwarzamy na podstawie:
          <ul className="list-disc pl-5">
            <li>
              Twojej zgody (art. 6 ust. 1 lit. a RODO), np. przy newsletterze i
              rezerwacjach
            </li>
            <li>
              Niezbędności do wykonania umowy (art. 6 ust. 1 lit. b RODO), np. w
              przypadku realizacji rezerwacji
            </li>
            <li>
              Uzasadnionego interesu administratora (art. 6 ust. 1 lit. f RODO),
              np. analityki ruchu
            </li>
          </ul>
        </p>

        <h2 className="text-lg font-semibold mt-6 mb-2">
          5. Pliki cookies i Google Analytics
        </h2>
        <p className="mb-4">
          Nasza strona wykorzystuje pliki cookies w celach technicznych oraz
          analitycznych. Korzystamy z Google Analytics 4, który gromadzi
          anonimowe dane o ruchu na stronie. Pliki cookies możesz w każdej
          chwili usunąć lub zablokować w ustawieniach przeglądarki.
        </p>

        <h2 className="text-lg font-semibold mt-6 mb-2">6. Newsletter</h2>
        <p className="mb-4">
          Jeśli zapiszesz się do naszego newslettera, Twój adres e-mail będzie
          wykorzystywany wyłącznie do przesyłania informacji marketingowych
          związanych z naszą restauracją. Możesz w każdej chwili zrezygnować z
          subskrypcji, klikając link wypisu w stopce wiadomości.
        </p>

        <h2 className="text-lg font-semibold mt-6 mb-2">7. Twoje prawa</h2>
        <p className="mb-4">
          Masz prawo dostępu do swoich danych, ich sprostowania, usunięcia,
          ograniczenia przetwarzania, przenoszenia danych oraz wniesienia
          sprzeciwu. Masz również prawo do złożenia skargi do Prezesa UODO.
        </p>

        <h2 className="text-lg font-semibold mt-6 mb-2">
          8. Dobrowolność podania danych
        </h2>
        <p className="mb-4">
          Podanie danych w formularzu rezerwacyjnym oraz przy zapisie na
          newsletter jest dobrowolne, ale niezbędne do realizacji wybranej
          funkcji (np. dokonania rezerwacji).
        </p>

        <p className="text-sm text-gray-400 mt-6">
          Niniejsza polityka obowiązuje od 10 lipca 2025 r.
        </p>
      </div>
    </>
  );
}
